import { makeAutoObservable } from 'mobx'
import { apiClient } from '../../service/ApiClient'
import { CreateLocationDTO, Location } from '../../types/models/Locations'

export class LocationStore {
  mainLocation: Location[] | undefined
  location: Location[] | undefined

  onDragStart: Location | undefined | null
  onDragOver: Location | undefined | null

  constructor() {
    makeAutoObservable(this)
  }

  async getAll(force?: boolean) {
    if (this.location && !force) return
    const { data } = await apiClient.get('/location/all')
    this.location = data
  }

  async getMainLocation(force?: boolean) {
    if (this.mainLocation && !force) return
    const { data } = await apiClient.get('/location')
    this.mainLocation = data
  }

  async createOne(dto: CreateLocationDTO) {
    await apiClient.post('/location', dto)
    this.getAll(true)
    this.getMainLocation(true)
  }

  async changeLocation(id: string | number, dto: CreateLocationDTO) {
    await apiClient.put(`/location/${id}`, dto)
    this.getAll(true)
    this.getMainLocation(true)
  }

  async delete(id: string | number) {
    await apiClient.delete(`/location/${id}`)
    this.getAll(true)
  }

}
